/**
 * Copyright (c) 2025-2026 eBUCIS, LLC. All rights reserved.
 *
 * Student/Coach sidebar mode helpers.
 *
 * A coach is also a student, so the left nav shows one role's menus at a time. These ids classify a
 * nav item as coach-only or shared (everything else is a student item).
 *
 * This software is proprietary and confidential. Unauthorized copying, distribution, or modification
 * is strictly prohibited.
 */

// Items shown only in Coach mode.
export const COACH_ITEM_IDS = new Set([
  'coach',
  'class-knowledge-map',
  'adaptive-teaching',
  'school-cockpit',
  'my-pod',
  'tutor-practices',
  'my-classes'
])

// Items shown in BOTH modes.
export const SHARED_ITEM_IDS = new Set(['calendar', 'whats-new', 'profile', 'calculator'])

/**
 * Filter a list of nav items to the active role mode.
 * @param {Array<{id: string}>} items
 * @param {'coach'|'student'} mode
 * @returns {Array} items visible in that mode
 */
export function filterNavItemsByMode(items, mode) {
  return items.filter((it) =>
    mode === 'coach'
      ? COACH_ITEM_IDS.has(it.id) || SHARED_ITEM_IDS.has(it.id)
      : !COACH_ITEM_IDS.has(it.id)
  )
}
